export default "__VITE_ASSET__erqIhlw6__"